import { j as m } from "./jsx-runtime-944c88e2.js";
import { S as Fe } from "./chunk-5PH6ULNP-da6977a4.js";
import { al as I, am as M, an as $e, ao as W, ap as C, aq as ne, ar as Se, as as re, at as Q, au as Qe, av as q, aw as $, ax as A, ay as ze, az as me, aA as ie, aB as Be, aC as Ge, aD as Ke, aE as P, aF as ge, aG as We, aH as xe, aI as He, aJ as qe, aK as be, aL as Je, aM as Ye, aN as G, aO as Xe, aP as z, aQ as Ze, aR as et, aS as _e, aT as tt, aU as nt, aV as rt, aW as it, aX as st, aY as ot, aZ as at, a_ as ut, a$ as ct, b0 as lt, b1 as ft, b2 as dt, b3 as ht, b4 as Ne, b5 as pt, b6 as vt, b7 as yt, T as k, u as St, b8 as mt, b9 as Ee, ba as gt } from "./eMyAsurionProvider-0702cfa3.js";
import { g as xt, l as we } from "./lodash-9598aa3c.js";
import * as ke from "react";
import Z, { useLayoutEffect as bt, useState as ve, useCallback as se, useEffect as _t } from "react";
import "@tanstack/react-query";
import "./useAccount-2367dbfe.js";
import "./myasurion-shared.mixpanel.es.js";
import { g as Et } from "./domains-8f7837df.js";
import { Stack as De, Heading as wt, Text as J, Flex as H, Box as Y, CheckboxGroup as Ot, Checkbox as Tt, Button as Ve, Center as Lt, Slider as Rt, SliderMark as It, SliderTrack as Ct, SliderFilledTrack as At, SliderThumb as jt } from "@chakra-ui/react";
import "@chakra-ui/icons";
import "./features-325864e1.js";
import "./providers-fe718bdb.js";
import "react-router-dom";
import "./cleave-react-node-c4a374e5.js";
import { S as Nt, g as oe, n as ae } from "./nps-reasons-1b4ba012.js";
import "@react-oauth/google";
import "./chunk-DMO4EI7P-a11dff68.js";
import "@emotion/react";
import "./myasurion-shared.carrier.es.js";
import "framer-motion";
import "./myasurion-shared.widgets.es.js";
import "./myasurion-shared.utils.es.js";
import "./myasurion-shared.colors.es.js";
import "./ProfileIcon-8cf21b72.js";
import "./myasurion-shared.profile.es.js";
import "react-dom";
import "@emotion/styled";
var pe = { exports: {} }, ue = {}, K = { exports: {} }, ce = {};
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Oe;
function kt() {
  if (Oe)
    return ce;
  Oe = 1;
  var r = Z;
  function e(u, o) {
    return u === o && (u !== 0 || 1 / u === 1 / o) || u !== u && o !== o;
  }
  var t = typeof Object.is == "function" ? Object.is : e, n = r.useState, i = r.useEffect, a = r.useLayoutEffect, s = r.useDebugValue;
  function l(u, o) {
    var d = o(), S = n({ inst: { value: d, getSnapshot: o } }), g = S[0].inst, y = S[1];
    return a(function() {
      g.value = d, g.getSnapshot = o, f(g) && y({ inst: g });
    }, [u, d, o]), i(function() {
      return f(g) && y({ inst: g }), u(function() {
        f(g) && y({ inst: g });
      });
    }, [u]), s(d), d;
  }
  function f(u) {
    var o = u.getSnapshot;
    u = u.value;
    try {
      var d = o();
      return !t(u, d);
    } catch {
      return !0;
    }
  }
  function p(u, o) {
    return o();
  }
  var c = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? p : l;
  return ce.useSyncExternalStore = r.useSyncExternalStore !== void 0 ? r.useSyncExternalStore : c, ce;
}
var le = {};
/**
 * @license React
 * use-sync-external-store-shim.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Te;
function Dt() {
  return Te || (Te = 1, process.env.NODE_ENV !== "production" && function() {
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
    var r = Z, e = r.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function t(h) {
      {
        for (var v = arguments.length, O = new Array(v > 1 ? v - 1 : 0), x = 1; x < v; x++)
          O[x - 1] = arguments[x];
        n("error", h, O);
      }
    }
    function n(h, v, O) {
      {
        var x = e.ReactDebugCurrentFrame, b = x.getStackAddendum();
        b !== "" && (v += "%s", O = O.concat([b]));
        var T = O.map(function(_) {
          return String(_);
        });
        T.unshift("Warning: " + v), Function.prototype.apply.call(console[h], console, T);
      }
    }
    function i(h, v) {
      return h === v && (h !== 0 || 1 / h === 1 / v) || h !== h && v !== v;
    }
    var a = typeof Object.is == "function" ? Object.is : i, s = r.useState, l = r.useEffect, f = r.useLayoutEffect, p = r.useDebugValue, c = !1, u = !1;
    function o(h, v, O) {
      c || r.startTransition !== void 0 && (c = !0, t("You are using an outdated, pre-release alpha of React 18 that does not support useSyncExternalStore. The use-sync-external-store shim will not work correctly. Upgrade to a newer pre-release."));
      var x = v();
      if (!u) {
        var b = v();
        a(x, b) || (t("The result of getSnapshot should be cached to avoid an infinite loop"), u = !0);
      }
      var T = s({
        inst: {
          value: x,
          getSnapshot: v
        }
      }), _ = T[0].inst, j = T[1];
      return f(function() {
        _.value = x, _.getSnapshot = v, d(_) && j({
          inst: _
        });
      }, [h, x, v]), l(function() {
        d(_) && j({
          inst: _
        });
        var V = function() {
          d(_) && j({
            inst: _
          });
        };
        return h(V);
      }, [h]), p(x), x;
    }
    function d(h) {
      var v = h.getSnapshot, O = h.value;
      try {
        var x = v();
        return !a(O, x);
      } catch {
        return !0;
      }
    }
    function S(h, v, O) {
      return v();
    }
    var g = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u", y = !g, E = y ? S : o, w = r.useSyncExternalStore !== void 0 ? r.useSyncExternalStore : E;
    le.useSyncExternalStore = w, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
  }()), le;
}
var Le;
function Me() {
  return Le || (Le = 1, process.env.NODE_ENV === "production" ? K.exports = kt() : K.exports = Dt()), K.exports;
}
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Re;
function Vt() {
  if (Re)
    return ue;
  Re = 1;
  var r = Z, e = Me();
  function t(p, c) {
    return p === c && (p !== 0 || 1 / p === 1 / c) || p !== p && c !== c;
  }
  var n = typeof Object.is == "function" ? Object.is : t, i = e.useSyncExternalStore, a = r.useRef, s = r.useEffect, l = r.useMemo, f = r.useDebugValue;
  return ue.useSyncExternalStoreWithSelector = function(p, c, u, o, d) {
    var S = a(null);
    if (S.current === null) {
      var g = { hasValue: !1, value: null };
      S.current = g;
    } else
      g = S.current;
    S = l(function() {
      function E(x) {
        if (!w) {
          if (w = !0, h = x, x = o(x), d !== void 0 && g.hasValue) {
            var b = g.value;
            if (d(b, x))
              return v = b;
          }
          return v = x;
        }
        if (b = v, n(h, x))
          return b;
        var T = o(x);
        return d !== void 0 && d(b, T) ? b : (h = x, v = T);
      }
      var w = !1, h, v, O = u === void 0 ? null : u;
      return [function() {
        return E(c());
      }, O === null ? void 0 : function() {
        return E(O());
      }];
    }, [c, u, o, d]);
    var y = i(p, S[0], S[1]);
    return s(function() {
      g.hasValue = !0, g.value = y;
    }, [y]), f(y), y;
  }, ue;
}
var fe = {};
/**
 * @license React
 * use-sync-external-store-shim/with-selector.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ie;
function Mt() {
  return Ie || (Ie = 1, process.env.NODE_ENV !== "production" && function() {
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
    var r = Z, e = Me();
    function t(c, u) {
      return c === u && (c !== 0 || 1 / c === 1 / u) || c !== c && u !== u;
    }
    var n = typeof Object.is == "function" ? Object.is : t, i = e.useSyncExternalStore, a = r.useRef, s = r.useEffect, l = r.useMemo, f = r.useDebugValue;
    function p(c, u, o, d, S) {
      var g = a(null), y;
      g.current === null ? (y = {
        hasValue: !1,
        value: null
      }, g.current = y) : y = g.current;
      var E = l(function() {
        var O = !1, x, b, T = function(N) {
          if (!O) {
            O = !0, x = N;
            var R = d(N);
            if (S !== void 0 && y.hasValue) {
              var F = y.value;
              if (S(F, R))
                return b = F, F;
            }
            return b = R, R;
          }
          var Ue = x, ee = b;
          if (n(Ue, N))
            return ee;
          var te = d(N);
          return S !== void 0 && S(ee, te) ? ee : (x = N, b = te, te);
        }, _ = o === void 0 ? null : o, j = function() {
          return T(u());
        }, V = _ === null ? void 0 : function() {
          return T(_());
        };
        return [j, V];
      }, [u, o, d, S]), w = E[0], h = E[1], v = i(c, w, h);
      return s(function() {
        y.hasValue = !0, y.value = v;
      }, [v]), f(v), v;
    }
    fe.useSyncExternalStoreWithSelector = p, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
  }()), fe;
}
process.env.NODE_ENV === "production" ? pe.exports = Vt() : pe.exports = Mt();
var Pt = pe.exports, Ut = {
  deferEvents: !1
}, Ce = (
  /** @class */
  /* @__PURE__ */ function() {
    function r(e) {
      this.processingEvent = !1, this.queue = [], this.initialized = !1, this.options = I(I({}, Ut), e);
    }
    return r.prototype.initialize = function(e) {
      if (this.initialized = !0, e) {
        if (!this.options.deferEvents) {
          this.schedule(e);
          return;
        }
        this.process(e);
      }
      this.flushEvents();
    }, r.prototype.schedule = function(e) {
      if (!this.initialized || this.processingEvent) {
        this.queue.push(e);
        return;
      }
      if (this.queue.length !== 0)
        throw new Error("Event queue should be empty when it is not processing events");
      this.process(e), this.flushEvents();
    }, r.prototype.clear = function() {
      this.queue = [];
    }, r.prototype.flushEvents = function() {
      for (var e = this.queue.shift(); e; )
        this.process(e), e = this.queue.shift();
    }, r.prototype.process = function(e) {
      this.processingEvent = !0;
      try {
        e();
      } catch (t) {
        throw this.clear(), t;
      } finally {
        this.processingEvent = !1;
      }
    }, r;
  }()
), de = /* @__PURE__ */ new Map(), Ft = 0, B = {
  bookId: function() {
    return "x:".concat(Ft++);
  },
  register: function(r, e) {
    return de.set(r, e), r;
  },
  get: function(r) {
    return de.get(r);
  },
  free: function(r) {
    de.delete(r);
  }
};
function ye() {
  if (typeof globalThis < "u")
    return globalThis;
  if (typeof self < "u")
    return self;
  if (typeof window < "u")
    return window;
  if (typeof global < "u")
    return global;
  M || console.warn("XState could not find a global object in this environment. Please let the maintainers know and raise an issue here: https://github.com/statelyai/xstate/issues");
}
function $t() {
  var r = ye();
  if (r && "__xstate__" in r)
    return r.__xstate__;
}
function Qt(r) {
  if (ye()) {
    var e = $t();
    e && e.register(r);
  }
}
function zt(r, e) {
  e === void 0 && (e = {});
  var t = r.initialState, n = /* @__PURE__ */ new Set(), i = [], a = !1, s = function() {
    if (!a) {
      for (a = !0; i.length > 0; ) {
        var p = i.shift();
        t = r.transition(t, p, f), n.forEach(function(c) {
          return c.next(t);
        });
      }
      a = !1;
    }
  }, l = $e({
    id: e.id,
    send: function(p) {
      i.push(p), s();
    },
    getSnapshot: function() {
      return t;
    },
    subscribe: function(p, c, u) {
      var o = W(p, c, u);
      return n.add(o), o.next(t), {
        unsubscribe: function() {
          n.delete(o);
        }
      };
    }
  }), f = {
    parent: e.parent,
    self: l,
    id: e.id || "anonymous",
    observers: n
  };
  return t = r.start ? r.start(f) : t, l;
}
var Bt = {
  sync: !1,
  autoForward: !1
}, L;
(function(r) {
  r[r.NotStarted = 0] = "NotStarted", r[r.Running = 1] = "Running", r[r.Stopped = 2] = "Stopped";
})(L || (L = {}));
var Gt = (
  /** @class */
  /* @__PURE__ */ function() {
    function r(e, t) {
      t === void 0 && (t = r.defaultOptions);
      var n = this;
      this.machine = e, this.delayedEventsMap = {}, this.listeners = /* @__PURE__ */ new Set(), this.contextListeners = /* @__PURE__ */ new Set(), this.stopListeners = /* @__PURE__ */ new Set(), this.doneListeners = /* @__PURE__ */ new Set(), this.eventListeners = /* @__PURE__ */ new Set(), this.sendListeners = /* @__PURE__ */ new Set(), this.initialized = !1, this.status = L.NotStarted, this.children = /* @__PURE__ */ new Map(), this.forwardTo = /* @__PURE__ */ new Set(), this._outgoingQueue = [], this.init = this.start, this.send = function(c, u) {
        if (Ze(c))
          return n.batch(c), n.state;
        var o = A(et(c, u));
        if (n.status === L.Stopped)
          return M || P(!1, 'Event "'.concat(o.name, '" was sent to stopped service "').concat(n.machine.id, `". This service has already reached its final state, and will not transition.
Event: `).concat(JSON.stringify(o.data))), n.state;
        if (n.status !== L.Running && !n.options.deferEvents)
          throw new Error('Event "'.concat(o.name, '" was sent to uninitialized service "').concat(
            n.machine.id,
            `". Make sure .start() is called for this service, or set { deferEvents: true } in the service options.
Event: `
          ).concat(JSON.stringify(o.data)));
        return n.scheduler.schedule(function() {
          n.forward(o);
          var d = n._nextState(o);
          n.update(d, o);
        }), n._state;
      }, this.sendTo = function(c, u, o) {
        var d = n.parent && (u === _e.Parent || n.parent.id === u), S = d ? n.parent : tt(u) ? u === _e.Internal ? n : n.children.get(u) || B.get(u) : nt(u) ? u : void 0;
        if (!S) {
          if (!d)
            throw new Error("Unable to send event to child '".concat(u, "' from service '").concat(n.id, "'."));
          M || P(!1, "Service '".concat(n.id, "' has no parent: unable to send event ").concat(c.type));
          return;
        }
        if ("machine" in S) {
          if (n.status !== L.Stopped || n.parent !== S || // we need to send events to the parent from exit handlers of a machine that reached its final state
          n.state.done) {
            var g = I(I({}, c), {
              name: c.name === rt ? "".concat(G(n.id)) : c.name,
              origin: n.sessionId
            });
            !o && n.machine.config.predictableActionArguments ? n._outgoingQueue.push([S, g]) : S.send(g);
          }
        } else
          !o && n.machine.config.predictableActionArguments ? n._outgoingQueue.push([S, c.data]) : S.send(c.data);
      }, this._exec = function(c, u, o, d) {
        d === void 0 && (d = n.machine.options.actions);
        var S = c.exec || it(c.type, d), g = $(S) ? S : S ? S.exec : c.exec;
        if (g)
          try {
            return g(u, o.data, n.machine.config.predictableActionArguments ? {
              action: c,
              _event: o
            } : {
              action: c,
              state: n.state,
              _event: o
            });
          } catch (F) {
            throw n.parent && n.parent.send({
              type: "xstate.error",
              data: F
            }), F;
          }
        switch (c.type) {
          case dt: {
            var y = c;
            n.defer(y);
            break;
          }
          case ft:
            var E = c;
            if (typeof E.delay == "number") {
              n.defer(E);
              return;
            } else
              E.to ? n.sendTo(E._event, E.to, o === ne) : n.send(E._event);
            break;
          case lt:
            n.cancel(c.sendId);
            break;
          case at: {
            if (n.status !== L.Running)
              return;
            var w = c.activity;
            if (
              // in v4 with `predictableActionArguments` invokes are called eagerly when the `this.state` still points to the previous state
              !n.machine.config.predictableActionArguments && !n.state.activities[w.id || w.type]
            )
              break;
            if (w.type === ut.Invoke) {
              var h = ct(w.src), v = n.machine.options.services ? n.machine.options.services[h.type] : void 0, O = w.id, x = w.data;
              M || P(
                !("forward" in w),
                // tslint:disable-next-line:max-line-length
                "`forward` property is deprecated (found in invocation of '".concat(w.src, "' in in machine '").concat(n.machine.id, "'). ") + "Please use `autoForward` instead."
              );
              var b = "autoForward" in w ? w.autoForward : !!w.forward;
              if (!v) {
                M || P(!1, "No service found for invocation '".concat(w.src, "' in machine '").concat(n.machine.id, "'."));
                return;
              }
              var T = x ? Se(x, u, o) : void 0;
              if (typeof v == "string")
                return;
              var _ = $(v) ? v(u, o.data, {
                data: T,
                src: h,
                meta: w.meta
              }) : v;
              if (!_)
                return;
              var j = void 0;
              be(_) && (_ = T ? _.withContext(T) : _, j = {
                autoForward: b
              }), n.spawn(_, O, j);
            } else
              n.spawnActivity(w);
            break;
          }
          case ot: {
            n.stopChild(c.activity.id);
            break;
          }
          case st:
            var V = c, N = V.label, R = V.value;
            N ? n.logger(N, R) : n.logger(R);
            break;
          default:
            M || P(!1, "No implementation found for action type '".concat(c.type, "'"));
            break;
        }
      };
      var i = I(I({}, r.defaultOptions), t), a = i.clock, s = i.logger, l = i.parent, f = i.id, p = f !== void 0 ? f : e.id;
      this.id = p, this.logger = s, this.clock = a, this.parent = l, this.options = i, this.scheduler = new Ce({
        deferEvents: this.options.deferEvents
      }), this.sessionId = B.bookId();
    }
    return Object.defineProperty(r.prototype, "initialState", {
      get: function() {
        var e = this;
        return this._initialState ? this._initialState : Q(this, function() {
          return e._initialState = e.machine.initialState, e._initialState;
        });
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(r.prototype, "state", {
      /**
       * @deprecated Use `.getSnapshot()` instead.
       */
      get: function() {
        return M || P(this.status !== L.NotStarted, "Attempted to read state from uninitialized service '".concat(this.id, "'. Make sure the service is started first.")), this._state;
      },
      enumerable: !1,
      configurable: !0
    }), r.prototype.execute = function(e, t) {
      var n, i;
      try {
        for (var a = C(e.actions), s = a.next(); !s.done; s = a.next()) {
          var l = s.value;
          this.exec(l, e, t);
        }
      } catch (f) {
        n = {
          error: f
        };
      } finally {
        try {
          s && !s.done && (i = a.return) && i.call(a);
        } finally {
          if (n)
            throw n.error;
        }
      }
    }, r.prototype.update = function(e, t) {
      var n, i, a, s, l, f, p, c, u = this;
      if (e._sessionid = this.sessionId, this._state = e, (!this.machine.config.predictableActionArguments || // this is currently required to execute initial actions as the `initialState` gets cached
      // we can't just recompute it (and execute actions while doing so) because we try to preserve identity of actors created within initial assigns
      t === ne) && this.options.execute)
        this.execute(this.state);
      else
        for (var o = void 0; o = this._outgoingQueue.shift(); )
          o[0].send(o[1]);
      if (this.children.forEach(function(_) {
        u.state.children[_.id] = _;
      }), this.devTools && this.devTools.send(t.data, e), e.event)
        try {
          for (var d = C(this.eventListeners), S = d.next(); !S.done; S = d.next()) {
            var g = S.value;
            g(e.event);
          }
        } catch (_) {
          n = {
            error: _
          };
        } finally {
          try {
            S && !S.done && (i = d.return) && i.call(d);
          } finally {
            if (n)
              throw n.error;
          }
        }
      try {
        for (var y = C(this.listeners), E = y.next(); !E.done; E = y.next()) {
          var g = E.value;
          g(e, e.event);
        }
      } catch (_) {
        a = {
          error: _
        };
      } finally {
        try {
          E && !E.done && (s = y.return) && s.call(y);
        } finally {
          if (a)
            throw a.error;
        }
      }
      try {
        for (var w = C(this.contextListeners), h = w.next(); !h.done; h = w.next()) {
          var v = h.value;
          v(this.state.context, this.state.history ? this.state.history.context : void 0);
        }
      } catch (_) {
        l = {
          error: _
        };
      } finally {
        try {
          h && !h.done && (f = w.return) && f.call(w);
        } finally {
          if (l)
            throw l.error;
        }
      }
      if (this.state.done) {
        var O = e.configuration.find(function(_) {
          return _.type === "final" && _.parent === u.machine;
        }), x = O && O.doneData ? Se(O.doneData, e.context, t) : void 0;
        this._doneEvent = re(this.id, x);
        try {
          for (var b = C(this.doneListeners), T = b.next(); !T.done; T = b.next()) {
            var g = T.value;
            g(this._doneEvent);
          }
        } catch (_) {
          p = {
            error: _
          };
        } finally {
          try {
            T && !T.done && (c = b.return) && c.call(b);
          } finally {
            if (p)
              throw p.error;
          }
        }
        this._stop(), this._stopChildren(), B.free(this.sessionId);
      }
    }, r.prototype.onTransition = function(e) {
      return this.listeners.add(e), this.status === L.Running && e(this.state, this.state.event), this;
    }, r.prototype.subscribe = function(e, t, n) {
      var i = this, a = W(e, t, n);
      this.listeners.add(a.next), this.status !== L.NotStarted && a.next(this.state);
      var s = function() {
        i.doneListeners.delete(s), i.stopListeners.delete(s), a.complete();
      };
      return this.status === L.Stopped ? a.complete() : (this.onDone(s), this.onStop(s)), {
        unsubscribe: function() {
          i.listeners.delete(a.next), i.doneListeners.delete(s), i.stopListeners.delete(s);
        }
      };
    }, r.prototype.onEvent = function(e) {
      return this.eventListeners.add(e), this;
    }, r.prototype.onSend = function(e) {
      return this.sendListeners.add(e), this;
    }, r.prototype.onChange = function(e) {
      return this.contextListeners.add(e), this;
    }, r.prototype.onStop = function(e) {
      return this.stopListeners.add(e), this;
    }, r.prototype.onDone = function(e) {
      return this.status === L.Stopped && this._doneEvent ? e(this._doneEvent) : this.doneListeners.add(e), this;
    }, r.prototype.off = function(e) {
      return this.listeners.delete(e), this.eventListeners.delete(e), this.sendListeners.delete(e), this.stopListeners.delete(e), this.doneListeners.delete(e), this.contextListeners.delete(e), this;
    }, r.prototype.start = function(e) {
      var t = this;
      if (this.status === L.Running)
        return this;
      this.machine._init(), B.register(this.sessionId, this), this.initialized = !0, this.status = L.Running;
      var n = e === void 0 ? this.initialState : Q(this, function() {
        return Qe(e) ? t.machine.resolveState(e) : t.machine.resolveState(q.from(e, t.machine.context));
      });
      return this.options.devTools && this.attachDev(), this.scheduler.initialize(function() {
        t.update(n, ne);
      }), this;
    }, r.prototype._stopChildren = function() {
      this.children.forEach(function(e) {
        $(e.stop) && e.stop();
      }), this.children.clear();
    }, r.prototype._stop = function() {
      var e, t, n, i, a, s, l, f, p, c;
      try {
        for (var u = C(this.listeners), o = u.next(); !o.done; o = u.next()) {
          var d = o.value;
          this.listeners.delete(d);
        }
      } catch (b) {
        e = {
          error: b
        };
      } finally {
        try {
          o && !o.done && (t = u.return) && t.call(u);
        } finally {
          if (e)
            throw e.error;
        }
      }
      try {
        for (var S = C(this.stopListeners), g = S.next(); !g.done; g = S.next()) {
          var d = g.value;
          d(), this.stopListeners.delete(d);
        }
      } catch (b) {
        n = {
          error: b
        };
      } finally {
        try {
          g && !g.done && (i = S.return) && i.call(S);
        } finally {
          if (n)
            throw n.error;
        }
      }
      try {
        for (var y = C(this.contextListeners), E = y.next(); !E.done; E = y.next()) {
          var d = E.value;
          this.contextListeners.delete(d);
        }
      } catch (b) {
        a = {
          error: b
        };
      } finally {
        try {
          E && !E.done && (s = y.return) && s.call(y);
        } finally {
          if (a)
            throw a.error;
        }
      }
      try {
        for (var w = C(this.doneListeners), h = w.next(); !h.done; h = w.next()) {
          var d = h.value;
          this.doneListeners.delete(d);
        }
      } catch (b) {
        l = {
          error: b
        };
      } finally {
        try {
          h && !h.done && (f = w.return) && f.call(w);
        } finally {
          if (l)
            throw l.error;
        }
      }
      if (!this.initialized)
        return this;
      this.initialized = !1, this.status = L.Stopped, this._initialState = void 0;
      try {
        for (var v = C(Object.keys(this.delayedEventsMap)), O = v.next(); !O.done; O = v.next()) {
          var x = O.value;
          this.clock.clearTimeout(this.delayedEventsMap[x]);
        }
      } catch (b) {
        p = {
          error: b
        };
      } finally {
        try {
          O && !O.done && (c = v.return) && c.call(v);
        } finally {
          if (p)
            throw p.error;
        }
      }
      this.scheduler.clear(), this.scheduler = new Ce({
        deferEvents: this.options.deferEvents
      });
    }, r.prototype.stop = function() {
      var e = this, t = this.scheduler;
      return this._stop(), t.schedule(function() {
        var n;
        if (!(!((n = e._state) === null || n === void 0) && n.done)) {
          var i = A({
            type: "xstate.stop"
          }), a = Q(e, function() {
            var s = ze(me([], ie(e.state.configuration), !1).sort(function(u, o) {
              return o.order - u.order;
            }).map(function(u) {
              return Be(u.onExit, e.machine.options.actions);
            })), l = ie(Ge(e.machine, e.state, e.state.context, i, [{
              type: "exit",
              actions: s
            }], e.machine.config.predictableActionArguments ? e._exec : void 0, e.machine.config.predictableActionArguments || e.machine.config.preserveActionOrder), 2), f = l[0], p = l[1], c = new q({
              value: e.state.value,
              context: p,
              _event: i,
              _sessionid: e.sessionId,
              historyValue: void 0,
              history: e.state,
              actions: f.filter(function(u) {
                return !Ke(u);
              }),
              activities: {},
              events: [],
              configuration: [],
              transitions: [],
              children: {},
              done: e.state.done,
              tags: e.state.tags,
              machine: e.machine
            });
            return c.changed = !0, c;
          });
          e.update(a, i), e._stopChildren(), B.free(e.sessionId);
        }
      }), this;
    }, r.prototype.batch = function(e) {
      var t = this;
      if (this.status === L.NotStarted && this.options.deferEvents)
        M || P(!1, "".concat(e.length, ' event(s) were sent to uninitialized service "').concat(this.machine.id, `" and are deferred. Make sure .start() is called for this service.
Event: `).concat(JSON.stringify(event)));
      else if (this.status !== L.Running)
        throw new Error(
          // tslint:disable-next-line:max-line-length
          "".concat(e.length, ' event(s) were sent to uninitialized service "').concat(this.machine.id, '". Make sure .start() is called for this service, or set { deferEvents: true } in the service options.')
        );
      if (e.length) {
        var n = !!this.machine.config.predictableActionArguments && this._exec;
        this.scheduler.schedule(function() {
          var i, a, s = t.state, l = !1, f = [], p = function(d) {
            var S = A(d);
            t.forward(S), s = Q(t, function() {
              return t.machine.transition(s, S, void 0, n || void 0);
            }), f.push.apply(f, me([], ie(t.machine.config.predictableActionArguments ? s.actions : s.actions.map(function(g) {
              return ht(g, s);
            })), !1)), l = l || !!s.changed;
          };
          try {
            for (var c = C(e), u = c.next(); !u.done; u = c.next()) {
              var o = u.value;
              p(o);
            }
          } catch (d) {
            i = {
              error: d
            };
          } finally {
            try {
              u && !u.done && (a = c.return) && a.call(c);
            } finally {
              if (i)
                throw i.error;
            }
          }
          s.changed = l, s.actions = f, t.update(s, A(e[e.length - 1]));
        });
      }
    }, r.prototype.sender = function(e) {
      return this.send.bind(this, e);
    }, r.prototype._nextState = function(e, t) {
      var n = this;
      t === void 0 && (t = !!this.machine.config.predictableActionArguments && this._exec);
      var i = A(e);
      if (i.name.indexOf(ge) === 0 && !this.state.nextEvents.some(function(s) {
        return s.indexOf(ge) === 0;
      }))
        throw i.data.data;
      var a = Q(this, function() {
        return n.machine.transition(n.state, i, void 0, t || void 0);
      });
      return a;
    }, r.prototype.nextState = function(e) {
      return this._nextState(e, !1);
    }, r.prototype.forward = function(e) {
      var t, n;
      try {
        for (var i = C(this.forwardTo), a = i.next(); !a.done; a = i.next()) {
          var s = a.value, l = this.children.get(s);
          if (!l)
            throw new Error("Unable to forward event '".concat(e, "' from interpreter '").concat(this.id, "' to nonexistant child '").concat(s, "'."));
          l.send(e);
        }
      } catch (f) {
        t = {
          error: f
        };
      } finally {
        try {
          a && !a.done && (n = i.return) && n.call(i);
        } finally {
          if (t)
            throw t.error;
        }
      }
    }, r.prototype.defer = function(e) {
      var t = this, n = this.clock.setTimeout(function() {
        "to" in e && e.to ? t.sendTo(e._event, e.to, !0) : t.send(e._event);
      }, e.delay);
      e.id && (this.delayedEventsMap[e.id] = n);
    }, r.prototype.cancel = function(e) {
      this.clock.clearTimeout(this.delayedEventsMap[e]), delete this.delayedEventsMap[e];
    }, r.prototype.exec = function(e, t, n) {
      n === void 0 && (n = this.machine.options.actions), this._exec(e, t.context, t._event, n);
    }, r.prototype.removeChild = function(e) {
      var t;
      this.children.delete(e), this.forwardTo.delete(e), (t = this.state) === null || t === void 0 || delete t.children[e];
    }, r.prototype.stopChild = function(e) {
      var t = this.children.get(e);
      t && (this.removeChild(e), $(t.stop) && t.stop());
    }, r.prototype.spawn = function(e, t, n) {
      if (this.status !== L.Running)
        return We(e, t);
      if (xe(e))
        return this.spawnPromise(Promise.resolve(e), t);
      if ($(e))
        return this.spawnCallback(e, t);
      if (He(e))
        return this.spawnActor(e, t);
      if (qe(e))
        return this.spawnObservable(e, t);
      if (be(e))
        return this.spawnMachine(e, I(I({}, n), {
          id: t
        }));
      if (Je(e))
        return this.spawnBehavior(e, t);
      throw new Error('Unable to spawn entity "'.concat(t, '" of type "').concat(typeof e, '".'));
    }, r.prototype.spawnMachine = function(e, t) {
      var n = this;
      t === void 0 && (t = {});
      var i = new r(e, I(I({}, this.options), {
        parent: this,
        id: t.id || e.id
      })), a = I(I({}, Bt), t);
      a.sync && i.onTransition(function(l) {
        n.send(Ye, {
          state: l,
          id: i.id
        });
      });
      var s = i;
      return this.children.set(i.id, s), a.autoForward && this.forwardTo.add(i.id), i.onDone(function(l) {
        n.removeChild(i.id), n.send(A(l, {
          origin: i.id
        }));
      }).start(), s;
    }, r.prototype.spawnBehavior = function(e, t) {
      var n = zt(e, {
        id: t,
        parent: this
      });
      return this.children.set(t, n), n;
    }, r.prototype.spawnPromise = function(e, t) {
      var n, i = this, a = !1, s;
      e.then(function(f) {
        a || (s = f, i.removeChild(t), i.send(A(re(t, f), {
          origin: t
        })));
      }, function(f) {
        if (!a) {
          i.removeChild(t);
          var p = G(t, f);
          try {
            i.send(A(p, {
              origin: t
            }));
          } catch (c) {
            Xe(f, c, t), i.devTools && i.devTools.send(p, i.state), i.machine.strict && i.stop();
          }
        }
      });
      var l = (n = {
        id: t,
        send: function() {
        },
        subscribe: function(f, p, c) {
          var u = W(f, p, c), o = !1;
          return e.then(function(d) {
            o || (u.next(d), !o && u.complete());
          }, function(d) {
            o || u.error(d);
          }), {
            unsubscribe: function() {
              return o = !0;
            }
          };
        },
        stop: function() {
          a = !0;
        },
        toJSON: function() {
          return {
            id: t
          };
        },
        getSnapshot: function() {
          return s;
        }
      }, n[z] = function() {
        return this;
      }, n);
      return this.children.set(t, l), l;
    }, r.prototype.spawnCallback = function(e, t) {
      var n, i = this, a = !1, s = /* @__PURE__ */ new Set(), l = /* @__PURE__ */ new Set(), f, p = function(o) {
        f = o, l.forEach(function(d) {
          return d(o);
        }), !a && i.send(A(o, {
          origin: t
        }));
      }, c;
      try {
        c = e(p, function(o) {
          s.add(o);
        });
      } catch (o) {
        this.send(G(t, o));
      }
      if (xe(c))
        return this.spawnPromise(c, t);
      var u = (n = {
        id: t,
        send: function(o) {
          return s.forEach(function(d) {
            return d(o);
          });
        },
        subscribe: function(o) {
          var d = W(o);
          return l.add(d.next), {
            unsubscribe: function() {
              l.delete(d.next);
            }
          };
        },
        stop: function() {
          a = !0, $(c) && c();
        },
        toJSON: function() {
          return {
            id: t
          };
        },
        getSnapshot: function() {
          return f;
        }
      }, n[z] = function() {
        return this;
      }, n);
      return this.children.set(t, u), u;
    }, r.prototype.spawnObservable = function(e, t) {
      var n, i = this, a, s = e.subscribe(function(f) {
        a = f, i.send(A(f, {
          origin: t
        }));
      }, function(f) {
        i.removeChild(t), i.send(A(G(t, f), {
          origin: t
        }));
      }, function() {
        i.removeChild(t), i.send(A(re(t), {
          origin: t
        }));
      }), l = (n = {
        id: t,
        send: function() {
        },
        subscribe: function(f, p, c) {
          return e.subscribe(f, p, c);
        },
        stop: function() {
          return s.unsubscribe();
        },
        getSnapshot: function() {
          return a;
        },
        toJSON: function() {
          return {
            id: t
          };
        }
      }, n[z] = function() {
        return this;
      }, n);
      return this.children.set(t, l), l;
    }, r.prototype.spawnActor = function(e, t) {
      return this.children.set(t, e), e;
    }, r.prototype.spawnActivity = function(e) {
      var t = this.machine.options && this.machine.options.activities ? this.machine.options.activities[e.type] : void 0;
      if (!t) {
        M || P(!1, "No implementation found for activity '".concat(e.type, "'"));
        return;
      }
      var n = t(this.state.context, e);
      this.spawnEffect(e.id, n);
    }, r.prototype.spawnEffect = function(e, t) {
      var n;
      this.children.set(e, (n = {
        id: e,
        send: function() {
        },
        subscribe: function() {
          return {
            unsubscribe: function() {
            }
          };
        },
        stop: t || void 0,
        getSnapshot: function() {
        },
        toJSON: function() {
          return {
            id: e
          };
        }
      }, n[z] = function() {
        return this;
      }, n));
    }, r.prototype.attachDev = function() {
      var e = ye();
      if (this.options.devTools && e) {
        if (e.__REDUX_DEVTOOLS_EXTENSION__) {
          var t = typeof this.options.devTools == "object" ? this.options.devTools : void 0;
          this.devTools = e.__REDUX_DEVTOOLS_EXTENSION__.connect(I(I({
            name: this.id,
            autoPause: !0,
            stateSanitizer: function(n) {
              return {
                value: n.value,
                context: n.context,
                actions: n.actions
              };
            }
          }, t), {
            features: I({
              jump: !1,
              skip: !1
            }, t ? t.features : void 0)
          }), this.machine), this.devTools.init(this.state);
        }
        Qt(this);
      }
    }, r.prototype.toJSON = function() {
      return {
        id: this.id
      };
    }, r.prototype[z] = function() {
      return this;
    }, r.prototype.getSnapshot = function() {
      return this.status === L.NotStarted ? this.initialState : this._state;
    }, r.defaultOptions = {
      execute: !0,
      deferEvents: !0,
      clock: {
        setTimeout: function(e, t) {
          return setTimeout(e, t);
        },
        clearTimeout: function(e) {
          return clearTimeout(e);
        }
      },
      logger: /* @__PURE__ */ console.log.bind(console),
      devTools: !1
    }, r.interpret = Pe, r;
  }()
);
function Pe(r, e) {
  var t = new Gt(r, e);
  return t;
}
var Kt = bt;
function Ae(r) {
  var e = ke.useRef();
  return e.current || (e.current = { v: r() }), e.current.v;
}
var X = globalThis && globalThis.__assign || function() {
  return X = Object.assign || function(r) {
    for (var e, t = 1, n = arguments.length; t < n; t++) {
      e = arguments[t];
      for (var i in e)
        Object.prototype.hasOwnProperty.call(e, i) && (r[i] = e[i]);
    }
    return r;
  }, X.apply(this, arguments);
}, Wt = globalThis && globalThis.__rest || function(r, e) {
  var t = {};
  for (var n in r)
    Object.prototype.hasOwnProperty.call(r, n) && e.indexOf(n) < 0 && (t[n] = r[n]);
  if (r != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, n = Object.getOwnPropertySymbols(r); i < n.length; i++)
      e.indexOf(n[i]) < 0 && Object.prototype.propertyIsEnumerable.call(r, n[i]) && (t[n[i]] = r[n[i]]);
  return t;
}, Ht = globalThis && globalThis.__read || function(r, e) {
  var t = typeof Symbol == "function" && r[Symbol.iterator];
  if (!t)
    return r;
  var n = t.call(r), i, a = [], s;
  try {
    for (; (e === void 0 || e-- > 0) && !(i = n.next()).done; )
      a.push(i.value);
  } catch (l) {
    s = { error: l };
  } finally {
    try {
      i && !i.done && (t = n.return) && t.call(n);
    } finally {
      if (s)
        throw s.error;
    }
  }
  return a;
};
function qt(r, e) {
  var t = Ae(function() {
    return typeof r == "function" ? r() : r;
  });
  if (process.env.NODE_ENV !== "production" && typeof r != "function") {
    var n = Ht(ve(t), 1), i = n[0];
    r !== i && console.warn("Machine given to `useMachine` has changed between renders. This is not supported and might lead to unexpected results.\nPlease make sure that you pass the same Machine as argument each time.");
  }
  var a = e.context, s = e.guards, l = e.actions, f = e.activities, p = e.services, c = e.delays;
  e.state;
  var u = Wt(e, ["context", "guards", "actions", "activities", "services", "delays", "state"]), o = Ae(function() {
    var d = {
      context: a,
      guards: s,
      actions: l,
      activities: f,
      services: p,
      delays: c
    }, S = t.withConfig(d, function() {
      return X(X({}, t.context), a);
    });
    return Pe(S, u);
  });
  return Kt(function() {
    Object.assign(o.machine.options.actions, l), Object.assign(o.machine.options.guards, s), Object.assign(o.machine.options.activities, f), Object.assign(o.machine.options.services, p), Object.assign(o.machine.options.delays, c);
  }, [l, s, f, p, c]), o;
}
globalThis && globalThis.__read;
globalThis && globalThis.__values;
function Jt(r, e, t) {
  if (r.status === L.NotStarted)
    return !0;
  var n = t.changed === void 0 && (Object.keys(t.children).length > 0 || typeof e.changed == "boolean");
  return !(t.changed || n);
}
var Yt = globalThis && globalThis.__read || function(r, e) {
  var t = typeof Symbol == "function" && r[Symbol.iterator];
  if (!t)
    return r;
  var n = t.call(r), i, a = [], s;
  try {
    for (; (e === void 0 || e-- > 0) && !(i = n.next()).done; )
      a.push(i.value);
  } catch (l) {
    s = { error: l };
  } finally {
    try {
      i && !i.done && (t = n.return) && t.call(n);
    } finally {
      if (s)
        throw s.error;
    }
  }
  return a;
};
function Xt(r) {
  return r;
}
function Zt(r) {
  for (var e = [], t = 1; t < arguments.length; t++)
    e[t - 1] = arguments[t];
  var n = Yt(e, 1), i = n[0], a = i === void 0 ? {} : i, s = qt(r, a), l = se(function() {
    return s.status === L.NotStarted ? a.state ? q.create(a.state) : s.machine.initialState : s.getSnapshot();
  }, [s]), f = se(function(u, o) {
    return Jt(s, u, o);
  }, [s]), p = se(function(u) {
    var o = s.subscribe(u).unsubscribe;
    return o;
  }, [s]), c = Pt.useSyncExternalStoreWithSelector(p, l, l, Xt, f);
  return _t(function() {
    var u = a.state;
    return s.start(u ? q.create(u) : void 0), function() {
      s.stop(), s.status = L.NotStarted;
    };
  }, []), [c, s.send, s];
}
var en = Ne, tn = pt, nn = vt;
function rn(r) {
  return function(e, t, n) {
    var i = Object(e);
    if (!tn(e)) {
      var a = en(t);
      e = nn(e), t = function(l) {
        return a(i[l], l, i);
      };
    }
    var s = r(e, t, n);
    return s > -1 ? i[a ? e[s] : s] : void 0;
  };
}
var sn = rn;
function on(r, e, t, n) {
  for (var i = r.length, a = t + (n ? 1 : -1); n ? a-- : ++a < i; )
    if (e(r[a], a, r))
      return a;
  return -1;
}
var an = on, un = yt, je = 1 / 0, cn = 17976931348623157e292;
function ln(r) {
  if (!r)
    return r === 0 ? r : 0;
  if (r = un(r), r === je || r === -je) {
    var e = r < 0 ? -1 : 1;
    return e * cn;
  }
  return r === r ? r : 0;
}
var fn = ln, dn = fn;
function hn(r) {
  var e = dn(r), t = e % 1;
  return e === e ? t ? e - t : e : 0;
}
var pn = hn, vn = an, yn = Ne, Sn = pn, mn = Math.max;
function gn(r, e, t) {
  var n = r == null ? 0 : r.length;
  if (!n)
    return -1;
  var i = t == null ? 0 : Sn(t);
  return i < 0 && (i = mn(n + i, 0)), vn(r, yn(e), i);
}
var xn = gn, bn = sn, _n = xn, En = bn(_n), wn = En;
const U = /* @__PURE__ */ xt(wn), D = "NPS", On = () => /* @__PURE__ */ m.jsxs(De, { children: [
  /* @__PURE__ */ m.jsx(Nt, { width: "80x", height: "80px" }),
  /* @__PURE__ */ m.jsx(
    wt,
    {
      fontSize: "32px",
      fontWeight: "light",
      lineHeight: "39.68px",
      letterSpacing: "-0.352px",
      children: /* @__PURE__ */ m.jsx(
        k,
        {
          text: "Thanks for your feedback",
          translationKey: `${D}/completedHeading`
        }
      )
    }
  ),
  /* @__PURE__ */ m.jsx(J, { fontSize: "lg", lineHeight: "22.32px", children: /* @__PURE__ */ m.jsx(
    k,
    {
      text: "Your feedback is a huge part of improving the experience.",
      translationKey: `${D}/completedMessage`
    }
  ) })
] }), Tn = ({
  loading: r = !1,
  category: e = "PASSIVE",
  description: t = "",
  reasons: n = [],
  onSubmit: i
}) => {
  const [a, s] = ve([]);
  return (
    // remove height here
    /* @__PURE__ */ m.jsxs(H, { flexFlow: "column nowrap", align: "left", justify: "space-between", h: "700px", children: [
      /* @__PURE__ */ m.jsxs(Y, { p: 4, children: [
        /* @__PURE__ */ m.jsx(
          J,
          {
            fontSize: "2xl",
            fontWeight: "light",
            letterSpacing: "-0.264px",
            lineHeight: "31.68px",
            children: /* @__PURE__ */ m.jsx(
              k,
              {
                text: t,
                translationKey: `${D}/ReasonDescription-${e}`
              }
            )
          }
        ),
        /* @__PURE__ */ m.jsx(
          Ot,
          {
            isDisabled: r,
            onChange: (l) => s(l),
            children: /* @__PURE__ */ m.jsx(De, { spacing: 3, direction: "column", pt: 4, children: n.map((l, f) => /* @__PURE__ */ m.jsx(
              Tt,
              {
                colorScheme: "blackAlpha",
                borderColor: "brand.secondary",
                _checked: {
                  "& .chakra-checkbox__control": {
                    background: "brand.black",
                    border: "none"
                  }
                },
                value: l,
                children: /* @__PURE__ */ m.jsx(
                  k,
                  {
                    text: l,
                    translationKey: `${D}/reason${e}${f}`
                  }
                )
              },
              `${f}-reason`
            )) })
          }
        )
      ] }),
      /* @__PURE__ */ m.jsx(Y, { py: 6, px: 4, boxShadow: "0px -4px 8px 0px rgba(0, 0, 0, 0.04)", children: /* @__PURE__ */ m.jsx(
        Ve,
        {
          isDisabled: a.length < 1,
          isLoading: r,
          colorScheme: "primary",
          fontWeight: "bold",
          borderRadius: 8,
          w: "full",
          onClick: () => i(a),
          children: /* @__PURE__ */ m.jsx(k, { text: "Submit", translationKey: `${D}/submitButtonText` })
        }
      ) })
    ] })
  );
}, Ln = {
  mt: "-9",
  ml: "-1",
  fontWeight: "bold"
}, Rn = ({
  defaultScore: r = 1,
  onSubmit: e,
  useBrandStyle: t = !1,
  sliderDetails: n
}) => {
  var c, u;
  const [i, a] = ve(r), { data: s } = St(), { theme: l } = s, { colors: f } = l, p = ((u = (c = f == null ? void 0 : f.brand) == null ? void 0 : c.neutral) == null ? void 0 : u.deep) || "";
  return console.log("NPSSlider useBrandStyle", t, p), /* @__PURE__ */ m.jsxs(H, { flexFlow: "column wrap", align: "left", justify: "space-between", h: "700px", children: [
    /* @__PURE__ */ m.jsxs(Y, { p: 4, children: [
      /* @__PURE__ */ m.jsxs(H, { flexFlow: "column wrap", gap: 2, mb: 2, children: [
        /* @__PURE__ */ m.jsx(
          J,
          {
            fontSize: "32px",
            fontWeight: "light",
            lineHeight: "39.68px",
            letterSpacing: "-0.352px",
            children: /* @__PURE__ */ m.jsx(
              k,
              {
                text: "Your feedback is important to us",
                translationKey: `${D}/sliderTitle`
              }
            )
          }
        ),
        /* @__PURE__ */ m.jsx(J, { fontSize: "lg", lineHeight: "22.32px", children: /* @__PURE__ */ m.jsx(
          k,
          {
            text: "How likely are you to recommend to your friends and family?",
            translationKey: `${D}/sliderDescription`
          }
        ) })
      ] }),
      /* @__PURE__ */ m.jsxs(H, { flexFlow: "column wrap", py: "10px", gap: "40px", px: 4, children: [
        /* @__PURE__ */ m.jsxs(Lt, { fontSize: "lg", color: "primary.500", fontWeight: "bold", pt: "10px", children: [
          i > 8 && /* @__PURE__ */ m.jsx(
            k,
            {
              text: "Extremely likely",
              translationKey: `${D}/sliderHighLabel`
            }
          ),
          8 >= i && i > 6 && /* @__PURE__ */ m.jsx(
            k,
            {
              text: "Likely",
              translationKey: `${D}/sliderMedianLabel`
            }
          ),
          6 >= i && i > 0 && /* @__PURE__ */ m.jsx(
            k,
            {
              text: "Not at all likely",
              translationKey: `${D}/sliderLowLabel`
            }
          )
        ] }),
        /* @__PURE__ */ m.jsxs(
          Rt,
          {
            defaultValue: r,
            min: n == null ? void 0 : n.min,
            max: n == null ? void 0 : n.max,
            step: n == null ? void 0 : n.step,
            onChange: (o) => a(o),
            children: [
              n == null ? void 0 : n.ratings.map((o, d) => /* @__PURE__ */ m.jsx(
                It,
                {
                  value: o,
                  fontSize: i === o ? "xl" : "sm",
                  color: i === o ? "primary.500" : "",
                  top: i === o ? "1" : "",
                  ...Ln,
                  children: o
                },
                d
              )),
              /* @__PURE__ */ m.jsx(Ct, { bg: "#EDEDED", h: "7px", borderRadius: 8, children: /* @__PURE__ */ m.jsx(At, { bg: t ? p : "primary.500" }) }),
              /* @__PURE__ */ m.jsx(
                jt,
                {
                  boxSize: 5,
                  bg: t ? p : "primary.500",
                  _focus: { boxShadow: "none" }
                }
              )
            ]
          }
        )
      ] })
    ] }),
    /* @__PURE__ */ m.jsx(Y, { py: 6, px: 4, boxShadow: "0px -4px 8px 0px rgba(0, 0, 0, 0.04)", children: /* @__PURE__ */ m.jsx(
      Ve,
      {
        w: "full",
        colorScheme: "primary",
        fontWeight: "bold",
        borderRadius: 8,
        onClick: () => e(i),
        children: /* @__PURE__ */ m.jsx(k, { text: "Next", translationKey: `${D}/nextButtonText` })
      }
    ) })
  ] });
}, { useEffect: he } = ke, In = "SR_Creation", Cn = "NPS", sr = ({
  clientId: r,
  triggerPoint: e = In,
  surveyType: t = Cn,
  serviceRequestId: n = "",
  customerCaseNumber: i = "",
  sessionId: a = "",
  language: s = "en-US",
  mdn: l = "",
  config: f,
  onSubmit: p = we.noop,
  onError: c = we.noop,
  defaultScore: u = 10,
  useBrandStyle: o = !1,
  InteractionLineId: d = "",
  MobileNumber: S = "",
  sliderDetails: g = { min: 1, max: 10, step: 1, ratings: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10] }
}) => {
  const [y, E] = Zt(mt, {
    devTools: !1,
    services: {
      async getSurvey() {
        var O, x, b, T, _, j, V, N;
        const { data: h } = await Ee({
          baseURL: f.baseUrl,
          url: f.actions.getSurvey.path,
          headers: f.headers,
          method: f.actions.getSurvey.method,
          data: {
            GetSurveyQuestions: {
              ClientId: r,
              TriggerPoint: e,
              SurveyType: t,
              ServiceRequestId: n,
              Language: s,
              SessionId: a
            }
          }
        }), v = gt(
          (h == null ? void 0 : h.SurveyQuestions) || ((O = h.GetSurveyQuestionsResponse) == null ? void 0 : O.SurveyQuestions),
          [(R) => parseInt(R.DisplayOrder)]
        );
        return E("SET_CLIENT_ID", { id: r }), E("SET_SURVEY_ID", { id: v[0].SurveyId }), E("SET_SCORE_QUESTION_ID", {
          id: (x = U(v, { QuestionType: "NPS", QuestionOptions: "slider" })) == null ? void 0 : x.QuestionId
        }), E("SET_MDN", { mdn: l }), {
          PROMOTER: {
            questionId: (b = U(
              v,
              (R) => R.QuestionType.toLowerCase() === "promoter"
            )) == null ? void 0 : b.QuestionId,
            description: (T = U(
              v,
              (R) => R.QuestionType.toLowerCase() === "promoter"
            )) == null ? void 0 : T.QuestionDescription,
            reasons: oe(w).PROMOTER ?? ae.PROMOTER
          },
          PASSIVE: {
            questionId: (_ = U(
              v,
              (R) => R.QuestionType.toLowerCase() === "passive"
            )) == null ? void 0 : _.QuestionId,
            description: (j = U(
              v,
              (R) => R.QuestionType.toLowerCase() === "passive"
            )) == null ? void 0 : j.QuestionDescription,
            reasons: oe(w).PASSIVE ?? ae.PASSIVE
          },
          DETRACTOR: {
            questionId: (V = U(
              v,
              (R) => R.QuestionType.toLowerCase() === "detractor"
            )) == null ? void 0 : V.QuestionId,
            description: (N = U(
              v,
              (R) => R.QuestionType.toLowerCase() === "detractor"
            )) == null ? void 0 : N.QuestionDescription,
            reasons: oe(w).DETRACTOR ?? ae.DETRACTOR
          }
        };
      },
      async submitSurvey(h) {
        let v = [];
        return h.customerCategory !== null && h.score !== null && (v = [
          {
            QuestionId: h.scoreQuestionId,
            Answer: h.score.toString()
          },
          {
            QuestionId: h.reasons[h.customerCategory].questionId,
            Answer: h.selectedReasons.join(",")
          }
        ]), (await Ee({
          baseURL: f.baseUrl,
          url: f.actions.submitSurvey.path,
          headers: f.headers,
          method: f.actions.submitSurvey.method,
          data: {
            SubmitSurveyAnswers: {
              SurveyId: h.surveyId,
              ClientId: h.clientId,
              // engagementId: '',
              mobileNumber: S,
              InteractionLineId: d,
              Results: v,
              // CacheId: '',
              CustomerCaseNumber: i,
              ServiceRequestId: n
            }
          }
        })).data;
      }
    }
  }), w = Et();
  return he(() => {
    r && E("FETCH");
  }, [r]), he(() => {
    y.context.surveyResult && (p == null || p(y.context.surveyResult));
  }, [y.context.surveyResult]), he(() => {
    y.context.errors && (c == null || c(y.context.errors));
  }, [y.context.errors]), /* @__PURE__ */ m.jsxs(m.Fragment, { children: [
    y.matches("fetchingSurvey") && y.hasTag("loading") && /* @__PURE__ */ m.jsx(Fe, { alignSelf: "center", justifySelf: "center" }),
    y.matches("surveyUnavailable") && /* @__PURE__ */ m.jsx(m.Fragment, { children: "Survey not available" }),
    y.matches("selectScore") && /* @__PURE__ */ m.jsx(
      Rn,
      {
        defaultScore: u,
        onSubmit: (h) => {
          E("SET_SCORE", { score: h }), E("SUBMIT_SCORE");
        },
        useBrandStyle: o,
        sliderDetails: g
      }
    ),
    (y.matches("selectReason") || y.matches("submittingSurvey")) && /* @__PURE__ */ m.jsx(
      Tn,
      {
        category: y.context.customerCategory,
        loading: y.hasTag("loading"),
        description: y.context.customerCategory === null ? "" : y.context.reasons[y.context.customerCategory].description,
        reasons: y.context.customerCategory === null ? [] : y.context.reasons[y.context.customerCategory].reasons,
        onSubmit: (h) => {
          E("UPDATE_REASONS", { selectedReasons: h }), E("SUBMIT_NPS");
        }
      }
    ),
    y.matches("surveySubmitted") && /* @__PURE__ */ m.jsx(On, {})
  ] });
};
export {
  On as Completed,
  sr as NPS,
  Tn as NPSReasons,
  Rn as NPSSlider,
  D as PAGE_NAME
};
